import { createAsyncThunk } from '@reduxjs/toolkit'
import TitleChangeLog from './title-change-log-model'
import {
  delete_titleChangeLog,
  load_titleChangeLogs,
  store_titleChangeLog,
} from './titleChangeLog-service'

export const LoadTitleChangeLogsAsync = createAsyncThunk<any, any>(
  'composer/load/titleChangeLog',
  async (params: { uid: string }) => {
    return await load_titleChangeLogs(params)
  },
)

export const CreateTitleChangeLogAsync = createAsyncThunk<any, any>(
  'composer/create/titleChangeLog',
  async (params: TitleChangeLog) => {
    return await store_titleChangeLog(params)
  },
)

export const DeleteTitleChangeLogAsync = createAsyncThunk<any, any>(
  'composer/delete/titleChangeLog',
  async (params) => {
    return await delete_titleChangeLog(params)
  },
)
